/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgChartSankey = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M18 4v2c-2.487 0-3.59.282-5.196 1.134l-.45.244c-1.82.993-2.95 1.445-4.353 1.578L8 11h10v2H8l.001 2.044c1.313.124 2.387.528 4.01 1.393l.56.304c1.658.906 2.723 1.23 5.083 1.257L18 18v2c-2.833 0-4.246-.368-6.128-1.364l-.476-.258c-1.859-1.014-2.769-1.344-4.16-1.375L7 17H2V7h5c1.368 0 2.237-.246 3.81-1.065l.802-.43c1.929-1.055 3.302-1.469 6.01-1.503zm4 14v2h-2v-2zM6 9H4v6h2zm16 2v2h-2v-2zm0-7v2h-2V4z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgChartSankey as ChartSankey };
